import React from 'react';
import { f7, Page, Navbar, List, ListInput } from 'framework7-react';
import { Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { createNewPassword } from '@api';
import { convertObjectToFormData } from '@utils';

interface FormValues {
  email: string;
}

const CreatePasswordSchema = Yup.object().shape({
  email: Yup.string().email().required('필수 입력 항목입니다.'),
});

const initialValues: FormValues = { email: '' };

const PasswordNewPage = () => {
  const handleSubmit = async (params, setSubmitting) => {
    setSubmitting(true);
    try {
      const fd = convertObjectToFormData({ modelName: 'user', data: params });
      const response = await createNewPassword(fd);
      if (response?.data?.status === 'ok') {
        f7.dialog.alert('비밀번호 재설정 링크가 포함된 메일이 발송되었습니다. 메일을 확인해주세요.');
      } else if (response?.data?.status === 'none') {
        f7.dialog.alert('입력하신 메일은 가입되지 않은 메일입니다. 다시 확인해주세요.');
      } else {
        f7.dialog.alert('비밀번호 재설정 메일 전송 중 문제가 발생하였습니다. 문제가 계속되면 관리자에게 문의해주세요.');
      }
    } catch (error) {
      f7.dialog.alert('입력된 정보를 다시 확인해주세요.');
      setSubmitting(false);
    }
  };

  return (
    <Page className="bg-white" noToolbar>
      <Navbar title="비밀번호 찾기" backLink sliding={false} />
      <Formik
        initialValues={initialValues}
        validationSchema={CreatePasswordSchema}
        onSubmit={(values, { setSubmitting }: FormikHelpers<FormValues>) => handleSubmit(values, setSubmitting)}
        validateOnMount
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, isValid }) => (
          <form onSubmit={handleSubmit} className="space-y-8 divide-y divide-gray-200">
            <List>
              <h3 className="text-lg leading-6 font-semibold text-gray-900 mx-4 mb-3">이메일 입력</h3>
              <ListInput
                label={i18next.t('login.email')}
                name="email"
                type="email"
                placeholder="이메일을 입력해주세요."
                clearButton
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                errorMessageForce
                errorMessage={touched.email && errors.email}
              />
              <small className="mx-4 mb-3">비밀번호 재설정 링크가 포함된 이메일이 전송됩니다.</small>
            </List>
            <div className="p-4">
              <button
                type="submit"
                className="button button-fill button-large disabled:opacity-50"
                disabled={isSubmitting || !isValid}
              >
                비밀번호 재설정
              </button>
            </div>
          </form>
        )}
      </Formik>
    </Page>
  );
};

export default React.memo(PasswordNewPage);
